import { useStore } from "../lib/store";
import { cx } from "./ui";

const TONE: Record<string, string> = {
  error: "border-red-500/30 bg-[#1a0c0c]/90 text-red-100",
  warn: "border-live/30 bg-[#1a1408]/90 text-amber-100",
  info: "border-teal/15 bg-navy/90 text-ink",
  ok: "border-teal/30 bg-[#06201c]/90 text-teal",
};

/**
 * Stacked toasts for API `detail` and WS notices.
 */
export function ToastHost() {
  const { state, dismissToast } = useStore();
  if (!state.toasts.length) return null;
  return (
    <div className="pointer-events-none fixed top-20 right-4 z-50 flex w-full max-w-sm flex-col gap-2">
      {state.toasts.map((toast) => (
        <button
          key={toast.id}
          type="button"
          className={cx(
            "pointer-events-auto rounded-xl px-4 py-3 text-left text-sm hairline",
            TONE[toast.level],
          )}
          onClick={() => dismissToast(toast.id)}
        >
          {toast.message}
        </button>
      ))}
    </div>
  );
}
